<label class="switch" [attr.data-testid]="testId + '-label'">
  <input type="checkbox" [attr.data-testid]="testId" [(ngModel)]="model" (change)="emitSwitchValue($event)" [disabled]="disabled" [khA11ySwitch]="model">
  <span class="track"></span>
</label>
